import { SdTableMethods } from "./table";
import { GlobalTableConstants } from "./table-constants";
import { SampleTablePager } from "./table.paging.harness";

export class TableHarnessController {
  public mediumTableData: any[];
  public shouldHide = false;
  public largeRowData: any[] = [];
  private rowNum = 1;
  public largeTableRowCount = 1000;
  public showTable = true;
  public exportFormatter = (cellValue: string) => cellValue.toUpperCase();

  public rowData2IdFetcher(data: any) {
    return data.caseId;
  }

  public testInnerData: any[] = [
    {
      test1: "foo1",
      test2: "foo2",
      test3: "foo3"
    },
    {
      test1: "bar1",
      test2: "bar2",
      test3: "bar3"
    },
    {
      test1: "lux1",
      test2: "lux2",
      test3: "lux3"
    }
  ];

  public rowData: any[] = [
    {
      comm: {
        test: "2"
      },
      caseId: "1335846225",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Power Supply replacement Fulfillment",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Chase Was Here!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1653546513",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Bleh!"
    },
    {
      comm: {
        test: "0"
      },
      caseId: "5432154915",
      state: "Open",
      status: "Resolving the issue",
      channel: "Web",
      language: "EN-US",
      product: "Windows",
      category: "Accounts & Billing",
      issue: "License Key inactive",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Chase Wilson",
      notShown: "Bleh!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1425689113",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "O365",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Pritam Das",
      owner: "Chase Wilson",
      notShown: "Bleh!"
    }
  ];

  public rowData2: any[] = [
    {
      comm: {
        test: "2"
      },
      caseId: "1335846225",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Power Supply replacement Fulfillment",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Chase Was Here!"
    },
    {
      comm: {
        test: "1"
      },
      caseId: "1653546513",
      state: "Open",
      status: "Resolving the issue",
      channel: "Phone",
      language: "EN-US",
      product: "Xbox",
      category: "Accounts & Billing",
      issue: "Overheating",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Vivek Manju",
      notShown: "Bleh!"
    },
    {
      comm: {
        test: "0"
      },
      caseId: "5432154915",
      state: "Open",
      status: "Resolving the issue",
      channel: "Web",
      language: "EN-US",
      product: "Windows",
      category: "Accounts & Billing",
      issue: "License Key inactive",
      created: "Apr 19, 2016 7:07 AM 12 hrs ago",
      lastUpdated: "Apr 19, 2016 7:07 AM 5 mins ago",
      lastClosed: "N/A",
      modifiedBy: "Kyle Geddes",
      owner: "Chase Wilson",
      notShown: "Bleh!",
      $sd: { rowViewModel: { expanded: true } }
    }
  ];

  public rowData2Save = this.rowData2;
  // @ngInject
  constructor(public tableConstants: GlobalTableConstants) {
    let testCallback = (event: any) => {
      console.log(event);
    };

    new SampleTablePager(this);

    (<any>this.rowData2).$sd = {
      sortModel: [{ columnId: "issue", sort: this.tableConstants.columnSortMethod.DESCENDING }],
      columnSizes: { ["issue"]: { width: 300 } },
      onRowSelectionChanged: () => {
        console.log("selected");
      }
    };
    this.rowData2[0].$sd = { onRowLifecycleEvent: testCallback.bind(this) };
    (<any>this.testInnerData).$sd = {
      onRowClicked: () => {
        console.log("inner row clicked");
      }
    };
    this.addRows();
  }

  public modifyData() {
    let issue = "Blue Screen of Death";
    if (this.rowData2[1].issue == issue) {
      issue = "Overheating";
    }
    this.rowData2[1].issue = issue;
    console.log("Table 2: row 2 issue changed");
  }

  public refreshTable() {
    (<any>this.rowData2).$sd.refreshTable();
    console.log("Table 2: Table refreshed");
  }

  public clickEvent(row: any, field: string) {
    console.log(JSON.stringify(row) + " field = " + field);
  }

  public provideNewData() {
    if (this.rowData2.length == 3) {
      this.rowData2 = this.rowData2.concat([]).splice(0, 2);
      console.log("Table 2: Assigned new data to the rowData2 object. Table should update automatically.");
    } else {
      this.rowData2 = this.rowData2Save;
    }
  }

  public assignNewInnerData() {
    let newLength = Math.floor(Math.random() * 10);
    let newData: any[] = [];
    for (let i = 0; i < newLength; i++) {
      let obj: any = {};
      obj.test1 = this.getRandomText();
      obj.test2 = this.getRandomText();
      obj.test3 = this.getRandomText();
      newData.push(obj);
    }
    this.testInnerData = newData;
  }

  private getRandomText() {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  public expandRow() {
    let filteredData = this.rowData2.find((data) => {
      return data.comm.test == "1";
    });
    if (filteredData) {
      (<any>this.rowData2).$sd.setRowExpansionState(filteredData, filteredData.$sd ? !filteredData.$sd.expanded : true);
    }
  }

  public addRows(): void {
    for (let i = 0; i < this.largeTableRowCount; i++) {
      let data: any = {};
      data.id = this.rowNum++;
      data.a = Math.random() * 10000;
      data.b = Math.random() * 10000;
      data.c = Math.random() * 10000;
      data.d = Math.random() * 10000;
      data.e = Math.random() * 10000;
      data.f = Math.random() * 10000;
      data.g = Math.random() * 10000;
      data.h = Math.random() * 10000;
      data.i = Math.random() * 10000;
      data.j = Math.random() * 10000;
      data.k = Math.random() * 10000;
      data.l = Math.random() * 10000;
      data.m = Math.random() * 10000;
      data.n = Math.random() * 10000;
      data.o = Math.random() * 10000;
      data.p = Math.random() * 10000;
      data.q = Math.random() * 10000;
      data.r = Math.random() * 10000;
      data.s = Math.random() * 10000;
      data.t = Math.random() * 10000;
      data.u = Math.random() * 10000;
      data.v = Math.random() * 10000;
      data.w = Math.random() * 10000;
      data.x = Math.random() * 10000;
      data.y = Math.random() * 10000;
      data.z = Math.random() * 10000;
      this.largeRowData.push(data);
    }
    this.mediumTableData = this.largeRowData.splice(0, 20);

    let clickedCallback = (clickedRow: any) => {
      let viewModel = <SdTableMethods>(<any>this.largeRowData).$sd;
      let rowsToSelect: any[] = [];
      if (clickedRow.$sd && clickedRow.$sd.expanded) {
        viewModel.setRowExpansionState(clickedRow, false);
      } else {
        viewModel.setRowExpansionState(clickedRow, true);
      }
      this.largeRowData.forEach((row: any) => {
        if (row.$sd && row.$sd.expanded) {
          rowsToSelect.push(row);
        }
      });
      if (rowsToSelect.length > 0) {
        viewModel.setRowSelection(rowsToSelect);
      }
    };
    (<any>this.largeRowData).$sd = { onRowClicked: clickedCallback.bind(this) };
  }

  public toggleHide(): void {
    this.shouldHide = !this.shouldHide;
  }

  public onSearch(searchText: string, rowItem: any, columnFieldDef: any): boolean {
    let rowDataKeys = Object.keys(rowItem.data);
    for (let i = 0; i < rowDataKeys.length; i++) {
      if (typeof rowItem.data[rowDataKeys[i]] == "string" && rowItem.data[rowDataKeys[i]].startsWith(searchText)) {
        return true;
      }
    }

    return false;
  }

  public exportLargeTableToCsv() {
    (<any>this.largeRowData).$sd.exportTableToCsv({
      fileName: "MUHAHAHAHAHA!.csv"
    });
  }

  public asStringComparator(o1: any, o2: any) {
    return (o1 + "").localeCompare(o2 + "");
  }
}

export class TabController {
  public tab = 1;
  public isSet(tab: number) {
    return this.tab == tab;
  }
  public setTab(tab: number) {
    this.tab = tab;
  }
}

class CustomHeightObjectController {
  private data: any;
  public content = "nothing";

  constructor(private $scope: any, private $timeout: ng.ITimeoutService) {
    let shouldWait = false;
    let rnd = (parseInt(this.data.id) % 5) + 1;
    if (rnd == 5) {
      this.content = "I am five rows tall. And I wait 5 seconds before communicating that.";
      shouldWait = true;
      this.$timeout(() => {
        this.content += " I finished waiting.";
        this.data.$sd.setRowHeight(rnd * 25);
      }, 5000);
    } else if (rnd == 4) {
      this.content = "I am four rows tall";
    } else if (rnd == 3) {
      this.content = "I am three rows tall";
    } else if (rnd == 2) {
      this.content = "I am two rows tall";
    } else if (rnd == 1) {
      this.content = "I am one row tall";
    }

    if (!shouldWait) {
      console.log("setting row height after the fact");
      this.data.$sd.setRowHeight(rnd * 25);
    }
  }
}
export const sdTableTestRandomHeightObject: ng.IComponentOptions = {
  bindings: {
    data: "<"
  },
  controller: CustomHeightObjectController,
  template: "<div>{{$ctrl.content}}</div>"
};
